/* eslint-disable */
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMyVWQueryParams } from '../hooks/useMyVWQueryParams';
import i18n from '../../localization/i18n';
import * as rk from '../../localization/resourceKeys';
import { StepLayout } from '../components/common/steplayout/StepLayout';
import Logger from '../../logger';
import { SessionContext } from '../../context/sessionContext';

const MyVWRegistrationQuestion: React.FC = () => {
  const navigate = useNavigate();
  const { buildSearch } = useMyVWQueryParams();
  const { sessionDetails } = useContext(SessionContext);

  return (
    <StepLayout
      title={<h2>{i18n.t(rk.TITLE_MYVW_REGISTRATION_QUESTION)}</h2>}
      primaryAction={{
        label: i18n.t(rk.BUTTON_MYVW_NO_CREATE_ACCOUNT),
        onClick: () => {
          Logger.info(
            'myVW registration question: clicked no create account button',
            'Location ==> /myVW/registration-question',
            sessionDetails,
          );
          navigate('/myVW/register' + buildSearch());
        },
        testId: 'register-intro-continue',
      }}
      secondaryAction={{
        label: i18n.t(rk.BUTTON_MYVW_YES_LOG_IN),
        onClick: () => {
          Logger.info(
            'myVW registration question: clicked yes log in button',
            'Location ==> /myVW/registration-question',
            sessionDetails,
          );
          navigate('/myVW/login' + buildSearch());
        },
        testId: 'register-intro-cancel',
      }}
    >
      <p className='u-mb-none'>{i18n.t(rk.TEXT_MYVW_REGISTRATION_QUESTION)}</p>
    </StepLayout>
  );
};

export default MyVWRegistrationQuestion;
